import React from 'react';

const SECTIONS = [
  {
    title: 'Making moves (both sides — turns alternate)',
    rows: [
      ['"e4" / "e five"', 'Pawn to that square'],
      ['"knight to b6"', 'Piece move (say the piece, then the square)'],
      ['"rook takes d5"', 'Capture'],
      ['"knight b1 to c3"', 'Disambiguate with the starting square'],
      ['"e2 to e4"', 'From–to move'],
      ['"castle" / "castle queenside"', 'Castling (kingside by default)'],
      ['"e8 promote to knight"', 'Promotion (queen if unspecified)'],
    ],
  },
  {
    title: 'Board control',
    rows: [
      ['"reset" / "new game"', 'Back to the starting position'],
      ['"undo" / "take back"', 'Undo the last action'],
      ['"redo"', 'Redo an undone action'],
      ['"flip the board"', 'View from the other side'],
      ['"white to move" / "black to move"', 'Hand the move to either side'],
      ['"clear the board"', 'Empty board (for setting up positions)'],
      ['"place white knight on c3"', 'Add a piece'],
      ['"remove d4"', 'Remove a piece'],
      ['"sudo d1 to h3"', 'Force a move, ignoring the rules (captures anything on the target square)'],
    ],
  },
  {
    title: 'Positions & extras',
    rows: [
      ['"load the italian game"', 'Named openings: Italian, Ruy Lopez, Sicilian, French, Caro-Kann, Queen\'s Gambit, King\'s Indian, London, Scholar\'s Mate'],
      ['"set up a queen endgame"', 'Practice endgames: queen, rook, king and pawn'],
      ['"evaluation on" / "evaluation off"', 'Toggle the engine eval bar'],
      ['"stop listening" / "start listening"', 'Mute or unmute the mic by voice'],
      ['"help"', 'Show this panel'],
      ['"close" / "never mind"', 'Close this panel'],
    ],
  },
];

export default function HelpPanel({ open, onClose }) {
  React.useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="vc-help-overlay" onClick={onClose}>
      <div className="vc-help" onClick={(e) => e.stopPropagation()}>
        <div className="vc-help-header">
          <h3>Voice commands</h3>
          <button className="vc-btn" onClick={onClose}>Close</button>
        </div>
        {SECTIONS.map((section) => (
          <div key={section.title} className="vc-help-section">
            <h4>{section.title}</h4>
            <table>
              <tbody>
                {section.rows.map(([cmd, desc]) => (
                  <tr key={cmd}>
                    <td className="vc-help-cmd">{cmd}</td>
                    <td>{desc}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
        <p className="vc-help-tip">
          Tip: you can also type any command (or standard notation like Nf3) in the text box.
        </p>
      </div>
    </div>
  );
}
